module.exports = __webpack_public_path__ + "img/up.e5d53c2b.svg";